<div class="row">
  <div class="field col-6">
    <label class="block">Line</label>
    <input type="text" pInputText class="p-inputtext" [(ngModel)]="lineSummary.name" [disabled]=true [style]="{'width':'100%'}" placeholder="line name ...">

  </div>
  <div class="field col-6">
    <label class="block">Quote</label>
    <input type="text" pInputText class="p-inputtext" [(ngModel)]="lineSummary.quoteID" [disabled]=true [style]="{'width':'100%'}" placeholder="quote Id ...">
  </div>
</div>
<div class="row">
  <div class="field col-6">
    <label class="block">Name</label>
    <input type="text" pInputText class="p-inputtext" [(ngModel)]="ticketToAdd.name" (ngModelChange)="checkValidation()" [style]="{'width':'100%'}" placeholder="enter your name">
    <small class="p-error block" *ngIf="!userNameIsValid">* A valid name is required (min 8 characters)</small>
  </div>
  <div class="field col-6">
    <label class="block">Phone</label>
    <input type="number" pInputText class="p-inputtext" (ngModelChange)="checkValidation()" [(ngModel)]="ticketToAdd.phone" [style]="{'width':'100%'}" placeholder="enter your phone">
    <small class="p-error block" *ngIf="!userPhoneIsValid">* A valid phone is required (11 numbers)</small>
  </div>
</div>
<div class="row">
  <div class="field col-6">
    <label class="block">Email</label>
    <input type="email" pInputText class="p-inputtext" [(ngModel)]="ticketToAdd.email" (ngModelChange)="checkValidation()" [style]="{'width':'100%'}" placeholder="enter your email" required>
    <small class="p-error block" *ngIf="!userEmailIsValid">* A valid email is required</small>
  </div>
  <div class="field col-6">
    <label class="block">Issue</label>
    <p-dropdown [options]="issuesOptions" [(ngModel)]="ticketToAdd.issue" [style]="{'width':'100%','height': '40px'}"
                optionLabel="label" optionValue="value" appendTo="body">

    </p-dropdown>
  </div>
</div>
<div class="row">
  <div class="field col-12">
    <label class="block">Notes</label>
    <textarea pInputTextarea class="p-inputtext" [rows]="4" [cols]="60" [style]="{'width':'100%'}"
              [maxLength]="300" [(ngModel)]="ticketToAdd.notes"></textarea>
  </div>

</div>
<div class="row">
  <div class="col-12">
    <p-button icon="pi pi-save" iconPos="left" label="Submit" (onClick)="submitTicket()" [loading]="isBtnLoading" style="float:right"></p-button>
  </div>
</div>


<p-confirmDialog id="confirmDialog" header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-dialog header="" *ngIf="showSRNumberDilaog" [(visible)]="showSRNumberDilaog"
          [modal]="true" [style]="{width: '50vw',color:'darkorange' }"
          [draggable]="false" [resizable]="true" [blockScroll]="false">
  <p>{{errorDesc}} with SR Number {{srNumber}}</p>
</p-dialog>


















<!--<div class="row">
  <div class="field col-6">
    <label class="block">Issue</label>
    <input type="text" pInputText class="p-inputtext" [(ngModel)]="issueDesc" (ngModelChange)="IsInvalidIssueDesc()" [style]="{'width':'100%'}" placeholder="issue description ...">
    <small *ngIf="!IsInvalidIssueDesc()" class="p-error block">* Required</small>
  </div>
  <div class="field col-6">-->
<!--*ngIf="dialogState =='edit'"-->
<!--<label class="block">Line</label>-->
<!--[disabled]="dialogState=='edit'"-->
<!--<input type="text" pInputText class="p-inputtext" [(ngModel)]="lineSummary.name" [disabled]=true [style]="{'width':'100%'}" placeholder="line name ...">

  </div>

</div>
<div class="row " style="text-align:right; margin-top:5px" >
  <div class="col-12 text-right">
    <p-button icon="pi pi-save" iconPos="left" label="Submit" (onClick)="submitTicket()" [loading]="isBtnLoading"></p-button>
    </div>



</div>-->
